<ex-dropdown
  [label]="compact ? undefined : (resolvedLabelKey | translate)"
  noInput
  size="small"
  [contentSized]="compact"
  [dropdownMenuClass]="compact ? 'ex-dropdown-menu--compact' : ''"
  [inputText]="activeItem && (activeItem.label | translate)"
  [inputWidth]="compact ? undefined : 126"
  [blackStyle]="!compact"
  [boldInputText]="compact"
  [dropdownPlacement]="compact ? 'left' : 'right'"
  [shadowBorder]="shadowBorder"
>
  @if (compact) {
    <ng-template exDropdownDisplay>
      <span class="sort-trigger">
        <span class="sort-trigger__label">{{ resolvedLabelKey | translate }}</span>
        <span class="sort-trigger__value">{{ activeItem?.label || '' | translate }}</span>
      </span>
    </ng-template>
  }
  <ng-template exDropdownContent>
    <div class="sort-items-container" [class.sort-items-container--compact]="compact">
      <button
        *ngFor="let item of items"
        class="sort-item"
        [ngClass]="{ active: item === activeItem }"
        (click)="onSort(item)"
        [disabled]="item === activeItem && item.unidirectional"
      >
        <div class="d-flex flex-column align-items-start flex-1">
          <div class="sort-name">{{ item.label | translate }}</div>
          <div *ngIf="item === activeItem" class="sort-description">{{ item.description && (item.description | translate) }}</div>
        </div>
        <div class="sort-icon" [hidden]="item !== activeItem || (item === activeItem && item.unidirectional)">
          <img
            [hidden]="invertArrowIcons ? item.direction === 'desc' : item.direction === 'asc'"
            src="/assets/images/icon-arrow-down-outline.svg"
            alt="desc-sort"
          />
          <img
            [hidden]="invertArrowIcons ? item.direction === 'asc' : item.direction === 'desc'"
            src="/assets/images/icon-arrow-up-outline.svg"
            alt="asc-sort"
          />
        </div>
      </button>
    </div>
  </ng-template>
</ex-dropdown>
